import script from "./CampaignInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./CampaignInfo.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__